enum DiscountsAction {
  ADD_DISCOUNT = 'discounts/addDiscount',
  UPDATE_DISCOUNT = 'discounts/updateDiscount'
}

export default DiscountsAction;
